import { render, staticRenderFns } from "./CandidateCardComplete.vue?vue&type=template&id=309a6e5c&"
import script from "./CandidateCardComplete.vue?vue&type=script&lang=js&"
export * from "./CandidateCardComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports